export const breakpoints = {
  mobile: "768px",
};
